import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { endpoints } from 'modules/endpoints'
import { TableFiltersProps } from 'modules/types'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { MonthFilter } from 'views/components/MonthFilter/MonthFilter'
import { ResponsiveFilters } from 'views/components/ResponsiveFilters/ResponsiveFilters'
import { CropsFilter, TeamsFilter } from 'views/components/TableFilters'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { defaultListRequestParams } from '../DealList'

export const DealFilters: FC<TableFiltersProps> = ({
  setListRequestParams,
  updateFilterState,
  listRequestParams,
  defaultFilterValues,
  isFiltersLoaded,
}) => {
  const { t } = useTranslation('deal')
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
    defaultFilters: defaultFilterValues,
  })

  const filterForAssignee = useMemo(
    () => (listRequestParams.filter.team ? { team: listRequestParams.filter.team } : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [listRequestParams.filter.team, isFiltersLoaded],
  )

  return (
    <ResponsiveFilters
      listRequestParams={listRequestParams}
      displayClearBtn={displayClearBtn}
      onReset={() =>
        setListRequestParams({
          ...defaultListRequestParams,
          filter: defaultFilterValues,
        })
      }
      updateFilterState={updateFilterState}
    >
      <MonthFilter value={listRequestParams.filter.month} updateFilterState={updateFilterState} allowClear={false} />
      <CropsFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
      <TeamsFilter
        listRequestParams={listRequestParams}
        updateFilterState={(data) => updateFilterState({ team: data.team, executor: undefined })}
      />

      <ABaseTableFilter
        id="assigneeFilter"
        onChange={(executor) => updateFilterState({ executor })}
        value={listRequestParams.filter.executor}
        getLabel={(label) => label.full_name}
        endpoint={endpoints.taskAssignees()}
        placeholder={t('common:assignee')}
        filter={filterForAssignee}
        searchField="search"
        simpleApiFormat
      />

      <ABaseTableFilter
        id="dealType"
        onChange={(deal_type) => updateFilterState({ deal_type })}
        value={listRequestParams.filter.deal_type}
        placeholder={t('deal:dealType')}
        endpoint={endpoints.dealTypes()}
        getLabel={(dto) => dto.label}
        filter={filterForAssignee}
        showSearch={false}
        simpleApiFormat
      />
      <ABaseTableFilter
        id="financialDirector"
        onChange={(approval_by_financial_director) => updateFilterState({ approval_by_financial_director })}
        getLabel={(dto) => dto.label}
        value={listRequestParams.filter.approval_by_financial_director}
        placeholder={t('finDirFilter.placeholder')}
        showSearch={false}
        simpleApiFormat
        endpoint={endpoints.finDirFilter()}
      />
      <ABaseTableFilter
        id="bidResponsible"
        onChange={(bid_responsible) => updateFilterState({ bid_responsible })}
        value={listRequestParams.filter.bid_responsible}
        getLabel={(label) => label.full_name}
        endpoint={endpoints.taskAssignees()}
        placeholder={t('responsibleForBid')}
        searchField="search"
        simpleApiFormat
      />
    </ResponsiveFilters>
  )
}
